import startCase from 'lodash/startCase';
import type { BadgeTone } from '@skupreme/shared/ui';
import { OrderStatus } from '@utility/constants/common';

const TONES: Record<string, BadgeTone> = {
  [OrderStatus.PendingShipment]: 'warning',
  [OrderStatus.PendingFulfillment]: 'info',
  [OrderStatus.PartiallyCompleted]: 'info',
  [OrderStatus.Shipped]: 'accent',
  [OrderStatus.Completed]: 'success',
  [OrderStatus.Returns]: 'caution',
  [OrderStatus.Canceled]: 'danger',
};

export function getOrderStatusTone(status?: string): BadgeTone {
  return (status && TONES[status]) || 'neutral';
}

/** The API mixes casings: `Pending Shipment` alongside `partially_completed`. */
export function formatOrderStatus(status?: string): string {
  return status ? startCase(status) : '';
}
